import useFilter from "./useFilter";

function Filter({ setShowform,refetch,setIsFilterApplied, setNewTotal }) {
  const { renderTabContent } = useFilter({setShowform,refetch,setIsFilterApplied,setNewTotal});

  return (
    <div>
      <form action="javascript:void(0)">{renderTabContent()}</form>
    </div>
  );
}

export default Filter;
